/**
 * The Cash coin: worn steel disc, raised rim, the c stamped into it, and a
 * spin on hover. NO BACKTICKS in this file, comments included.
 */
export default `
.bv-ccoin {
  --coin: 18px;
  position: relative; display: inline-block; flex: none; vertical-align: middle;
  width: var(--coin); height: var(--coin); border-radius: 50%;
  perspective: 120px;
}
.bv-ccoin-sm { --coin: 15px; }
.bv-ccoin-md { --coin: 20px; }
.bv-ccoin-lg { --coin: 30px; }
/* The disc itself. A second layer behind it, nudged down, is the coin's edge,
   so a quarter turn reads as a thick coin instead of a vanishing line. */
.bv-ccoin-face {
  position: absolute; inset: 0; display: grid; place-items: center; border-radius: 50%;
  font: 800 calc(var(--coin) * 0.62)/1 var(--font-display, var(--font-technical));
  color: #e9e2c4; letter-spacing: 0;
  text-shadow: 0 1px 0 rgba(0,0,0,0.85), 0 0 3px rgba(0,0,0,0.6), 0 -1px 0 rgba(255,255,255,0.25);
  background:
    radial-gradient(circle at 32% 26%, rgba(255,255,255,0.38), rgba(255,255,255,0) 46%),
    radial-gradient(circle, rgba(0,0,0,0) 56%, rgba(0,0,0,0.5) 100%),
    url('/clutter/coin.webp') center / cover no-repeat, #5a6660;
  box-shadow:
    0 calc(var(--coin) * 0.09) 0 #2c3430,
    0 calc(var(--coin) * 0.16) calc(var(--coin) * 0.2) rgba(0,0,0,0.65),
    inset 0 0 0 1px rgba(0,0,0,0.55);
  transform-style: preserve-3d; backface-visibility: visible;
  will-change: transform;
}
/* Spin when the coin, or anything that holds it, is hovered or focused. */
.bv-ccoin:hover .bv-ccoin-face,
:hover > .bv-ccoin .bv-ccoin-face,
:focus-visible > .bv-ccoin .bv-ccoin-face {
  animation: bv-ccoin-spin 0.9s cubic-bezier(0.3, 0.7, 0.2, 1);
}
@keyframes bv-ccoin-spin {
  0% { transform: rotateY(0deg); }
  100% { transform: rotateY(720deg); }
}
@media (prefers-reduced-motion: reduce) {
  .bv-ccoin:hover .bv-ccoin-face, :hover > .bv-ccoin .bv-ccoin-face, :focus-visible > .bv-ccoin .bv-ccoin-face { animation: none; }
}
`;
